import axios from "axios"

// Define the base menu structure
const baseMenuData = [
  {
    id: 1,
    title: "Home",
    link: "/home-3",
  },
  {
    id: 2,
    title: "About",
    link: "/about",
  },
  {
    id: 3,
    hasDropdown: true,
    title: "Products",
    link: "#",
    submenus: [], // Will be populated with categories
  },
    {
    id: 4,
    title: "Green Energy",
    link: "/green",
  },
    {
    id: 5,
    title: "Fire Safety",
    link: "/fire",
  },
  {
    id: 6,
    title: "Service",
    link: "/service",
  },
  {
    id: 7,
    title: "Contact",
    link: "/contact",
  },
  {
    id: 8,
    title: "Download Brochure",
    link: "#",
    isBrochure: true, // Special flag to identify this as the brochure download item
  },
  {
    id: 9,
    title: "Faq",
    link: "/faq",
  },
   {
    id: 10,
    title: "Career",
    link: "/career",
  },
]

// Function to fetch categories
const fetchCategories = async () => {
  try {
    const response = await axios.get(
      "https://admin.lumetiq.in/api/categories/read.php",
    )
    return response.data.records.map((record) => ({
      title: record.name,
      link: `/products/${record.name.toLowerCase()}`,
    }))
  } catch (error) {
    console.error("Error fetching categories:", error)
    return []
  }
}

// Export the base menu data as default
export default baseMenuData

// Export a function to get the complete menu data with categories
export const getFullMenuData = async () => {
  const categories = await fetchCategories()

  return baseMenuData.map((item) => {
    if (item.title === "Products") {
      return { ...item, submenus: categories }
    }
    return item
  })
}

// Export brochure download functionality
export const handleBrochureDownload = async (formData) => {
  try {
    // Send form data to PHP backend
    await axios.post("/sendEmail.php", formData)

    // After successful email, download the PDF
    const brochureUrl = "assets/LUMETIQ CATALOG-2020.pdf"
    const link = document.createElement("a")
    link.href = brochureUrl
    link.download = "Brochure.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    return { success: true, message: "Brochure downloaded successfully and email sent!" }
  } catch (error) {
    console.error("Error sending email:", error)
    return { success: false, message: "Failed to send email. Please try again." }
  }
}

// Export form validation function
export const validateBrochureForm = (formData) => {
  const errors = {}
  let isValid = true

  if (!formData.name) {
    errors.name = "Name is required."
    isValid = false
  }
  if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
    errors.mobile = "Enter a valid 10-digit mobile number."
    isValid = false
  }
  if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = "Enter a valid email address."
    isValid = false
  }

  return { isValid, errors }
}

